// Custom hook for managing booking form state and logic

import { useState } from 'react';
import { DEFAULT_FORM_DATA, MAIN_BOOKING_FLOW } from '../constants/bookingConstants';
import { validateStep } from '../utils/bookingValidation';

export const useBookingForm = ({ flow = MAIN_BOOKING_FLOW, initialData = {} } = {}) => {
  const resolvedFlow = Array.isArray(flow) && flow.length > 0 ? flow : MAIN_BOOKING_FLOW;
  const totalSteps = resolvedFlow.length;
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({ ...DEFAULT_FORM_DATA, ...initialData });
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateCurrentStep = (step) => {
    const newErrors = validateStep(step, formData, resolvedFlow);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep = () => {
    if (validateCurrentStep(currentStep)) {
      setCurrentStep(prev => Math.min(prev + 1, totalSteps));
    }
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  const resetForm = () => {
    setCurrentStep(1);
    setFormData({ ...DEFAULT_FORM_DATA, ...initialData });
    setErrors({});
  };

  return {
    currentStep,
    formData,
    errors,
    handleInputChange,
    validateCurrentStep,
    nextStep,
    prevStep,
    resetForm,
    setCurrentStep,
    setFormData,
    setErrors,
    totalSteps,
    flow: resolvedFlow
  };
};
